import './style.scss';


import './scripts/general';
import './scripts/header';
import './scripts/navigation';

import './scripts/advantagesSection';
import './scripts/testimonials_slider';
import './scripts/reveal_slider';
import './scripts/toggle_results';
import './scripts/history_slider';
import './scripts/content_text_slider';
import './scripts/homepage';
// import './scripts/homepage-hero-video';
import './scripts/rotation_videos';
import './scripts/page_treatment';
import './scripts/clinics';
import './scripts/patients-page';
import './scripts/formInputs';
import './scripts/smileValidate';
import './scripts/representatives_section';
import './scripts/courses-filters';
import './scripts/lang-switcher';



document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.aligners-braces-toggle-wrapper');
    if (!toggle) return;

    // console.log('we here')

    const alignersTab = document.querySelector('.prices-cases--tab[data-tab="aligners"]');
    const bracesTab = document.querySelector('.prices-cases--tab[data-tab="braces"]');
    if (!alignersTab || !bracesTab) return;

    document.querySelectorAll('[data-tabbtn]').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            switchTab(btn.dataset.tabbtn);
        });
    });

    toggle.addEventListener('click', () => {
        const bracesActive = bracesTab.classList.contains('active');
        switchTab(bracesActive ? 'aligners' : 'braces');
    });

    function switchTab(tab) {
        const toBraces = tab === 'braces';
        alignersTab.classList.toggle('active', !toBraces);
        bracesTab.classList.toggle('active', toBraces);
        toggle.classList.toggle('is-braces', toBraces);

        const parentList = document.querySelector('.aligner--braces--list--mobile');
        if (parentList) {
            parentList.style.background = toBraces
                ? 'var(--brand-light-grey, #FFF9F6)'
                : 'var(--primary-light-blue, #D4EEFF)';
        }
    }
});